import React from 'react'
import LockOutlined from '@material-ui/icons/LockOutlined'

export default function LockOutlinedIcon() {

    return (
        <LockOutlined />
    )
}